import React from "react";
import { FormGroup, Input } from "reactstrap";
import { updateStatusQuotation } from "actions/job";
import { showAlert } from "components/Common/commonFunctions";

export const handleQuotationStatus = ({
    type,
    quotationId,
    jobId,
    notify,
    setIsAPiProcessing,
    rejectReasonRef,
    onSuccess,
}) => {
    let rejectReason = "";

    const updateQuotation = async (status) => {
        const payload = {
            quotationID: quotationId,
            jobID: jobId,
            status,
        };

        if (status === "QUOTATION_REJECTED") {
            const current = rejectReasonRef?.current;
            const reasonRaw =
                typeof current === "string"
                    ? current
                    : current?.value ?? rejectReason ?? "";
            const reason = reasonRaw?.trim();

            if (!reason) {
                notify("danger", "Please enter the reason for rejecting the quotation.");
                return;
            }

            payload.rejectionReason = reason;
        }

        setIsAPiProcessing(true);
        try {
            const res = await updateStatusQuotation(payload);

            if (res?.code !== 200) {
                notify("danger", res?.message || "Failed to update quotation status.");
                return;
            }

            notify("success", res?.message);

            if (onSuccess) {
                await onSuccess();
            }
        } catch {
            notify("danger", "Something went wrong.");
        } finally {
            setIsAPiProcessing(false);
        }
    };

    if (type === "accept") {
        return showAlert({
            title: "Are you sure you want to accept this quotation?",
            type: "warning",
            message: "This action cannot be undone. Please confirm to continue.",
            confirmText: "Yes, Accept",
            cancelText: "No",
            confirmStyle: "default",
            onConfirm: () => updateQuotation("QUOTATION_APPROVED"),
        });
    }

    if (type === "reject") {
        return showAlert({
            title: "Are you sure you want to reject this quotation?",
            type: "warning",
            message: "This action cannot be undone. Please provide a reason for rejection.",
            confirmText: "Yes, Reject",
            cancelText: "No",
            confirmStyle: "danger",
            children: (
                <FormGroup className="mt-2">
                    <Input
                        innerRef={rejectReasonRef}
                        type="textarea"
                        placeholder="Enter reason *"
                        onChange={(e) => {
                            rejectReason = e.target.value;
                            if (rejectReasonRef) rejectReasonRef.current = e.target.value;
                        }}
                    />
                </FormGroup>
            ),
            onConfirm: () => updateQuotation("QUOTATION_REJECTED"),
        });
    }
};